// Web → Analytika → Mapa toku.
//
// Schéma, kudy ženy tečou funnelem. Kostra je pevná, čísla jsou skutečná
// z měření. Pod hlavní řadou visí odpady, tedy kolik jich v daném kroku web
// opustilo.
//
// DVĚ VĚTVE, ne jedna. Plná cena a tajná sleva jsou dva různé funnely:
// na /jsz/ se chodí z kvízu, na /jsz-sleva/ výhradně z e-mailu s odpočtem a
// s tokenem v adrese. Kreslit je do jedné řady by lhalo, protože by to
// vypadalo, že se sleva nabízí každé, kdo dojde na prodejku. Proto dvě řady
// pod sebou, zarovnané do stejných sloupců, ať jdou kroky porovnat očima.
//
// POZOR NA ADRESY: prodejní a nákupní stránky se v 7/2026 přejmenovaly na
// /jsz*. Mapa dlouho ukazovala nuly, protože držela staré /jidelnicek-*.
// Staré adresy tu proto zůstávají jako alias kvůli historickým datům.
//
// Kreslíme vlastním SVG, ne knihovnou. Sankey z rechartsu je na pár kroků
// zbytečně divoký a nejde do něj rozumně dostat popisky s čísly.
import React, { useMemo, useState } from "react";
import { Users, HelpCircle, FileText, ShoppingCart, CheckCircle2, LogOut, Maximize2, ZoomIn, ZoomOut, Tag } from "lucide-react";

const BRAND = "#6E519F";
const CARA = "#B9AACD";
const ODPAD = "#e11d48";
const ZELENA = "#059669";
const SLEVA = "#B45309";

const PATH_KVIZ = "/kviz/";
const PATH_PRODEJ = ["/jsz/", "/jidelnicek-spokojene-zeny/"];
const PATH_NAKUP = ["/jsz-nakup/", "/jidelnicek-spokojene-zeny-nakup/"];
const PATH_SLEVA = ["/jsz-sleva/"];
const PATH_SLEVA_NAKUP = ["/jsz-sleva-nakup/"];
const PATH_DEKUJI = ["/dekujeme-za-nakup/"];

const pct = (a, b) => (b > 0 ? Math.round((a / b) * 1000) / 10 : 0);
const cas = (s) => {
  const n = Number(s) || 0;
  if (n <= 0) return null;
  if (n < 60) return `${n} s`;
  return `${Math.floor(n / 60)} m ${String(Math.round(n % 60)).padStart(2, "0")} s`;
};

// Rozměry kreslicí plochy. Šířka je pevně na pět sloupců, i když má řada
// kroků míň — obě větve tak sedí pod sebou a dají se porovnat.
const OKRAJ = 28;
const UZEL_W = 180;
const UZEL_H = 100;
const MEZERA = 64;
const SLOUPCU = 5;
const W = OKRAJ * 2 + SLOUPCU * UZEL_W + (SLOUPCU - 1) * MEZERA;
const Y = 54;
const Y_ODPAD = 240;
const H_S_ODPADY = Y_ODPAD + 46 + 16; // konec odpadového rámečku plus dech
const H_BEZ = Y + UZEL_H + 34; // bez odchodů nemá smysl držet prázdné plátno

const x = (i) => OKRAJ + i * (UZEL_W + MEZERA);

/**
 * Jedna řada funnelu. `odsazeni` posune řadu doprava o daný počet sloupců,
 * aby se slevová větev zarovnala pod plnou cenu.
 */
function Schema({ kroky, odsazeni = 0, zoom, fit, barvaKonce = ZELENA, klic }) {
  const maOdpady = kroky.some((k) => k.odpad > 0);
  const H = maOdpady ? H_S_ODPADY : H_BEZ;

  return (
    <div className={fit ? "" : "overflow-x-auto"}>
      <svg
        width={fit ? "100%" : W * zoom}
        height={fit ? undefined : H * zoom}
        viewBox={`0 0 ${W} ${H}`}
        className="block"
        style={fit ? { width: "100%", height: "auto" } : undefined}
        preserveAspectRatio="xMidYMid meet"
      >
        {/* jemná mřížka na pozadí, ať to vypadá jako schéma a ne jako tabulka */}
        <defs>
          <pattern id={`mrizka-${klic}`} width="22" height="22" patternUnits="userSpaceOnUse">
            <path d="M 22 0 L 0 0 0 22" fill="none" stroke="#F1EEF6" strokeWidth="1" />
          </pattern>
          <marker id={`sipka-${klic}`} markerWidth="9" markerHeight="9" refX="7" refY="4.5" orient="auto">
            <path d="M0,0 L9,4.5 L0,9 z" fill={CARA} />
          </marker>
          <marker id={`sipkaOdpad-${klic}`} markerWidth="9" markerHeight="9" refX="7" refY="4.5" orient="auto">
            <path d="M0,0 L9,4.5 L0,9 z" fill={ODPAD} />
          </marker>
        </defs>
        <rect width={W} height={H} rx="12" fill={`url(#mrizka-${klic})`} />

        {/* spojnice mezi kroky */}
        {kroky.slice(0, -1).map((k, i) => {
          const dalsi = kroky[i + 1];
          const x1 = x(i + odsazeni) + UZEL_W;
          const x2 = x(i + 1 + odsazeni);
          const stred = (x1 + x2) / 2;
          const cy = Y + UZEL_H / 2;
          const prosly = dalsi.value;
          const podil = pct(prosly, k.value);

          return (
            <g key={`h-${k.key}`}>
              <line
                x1={x1} y1={cy} x2={x2 - 10} y2={cy}
                stroke={CARA} strokeWidth="2" strokeDasharray="5 4" markerEnd={`url(#sipka-${klic})`}
              />
              <rect
                x={stred - 27} y={cy - 27} width="54" height="22" rx="6"
                fill={podil >= 30 ? BRAND : "#9C8CB4"}
              />
              <text x={stred} y={cy - 11} textAnchor="middle" fill="#fff" fontSize="12" fontWeight="700">
                {prosly}
              </text>
              <text x={stred} y={cy + 22} textAnchor="middle" fill="#7A7387" fontSize="11" fontWeight="500">
                {podil} %
              </text>
            </g>
          );
        })}

        {/* odpady dolů */}
        {kroky.map((k, i) => {
          if (!k.odpad) return null;
          const cx = x(i + odsazeni) + UZEL_W / 2;
          const y1 = Y + UZEL_H;
          return (
            <g key={`o-${k.key}`}>
              <line
                x1={cx} y1={y1} x2={cx} y2={Y_ODPAD - 12}
                stroke={ODPAD} strokeWidth="1.8" strokeDasharray="4 4" markerEnd={`url(#sipkaOdpad-${klic})`}
              />
              <rect x={cx - 44} y={Y_ODPAD} width="88" height="46" rx="9" fill="#FFF1F3" stroke="#FBCFD8" />
              <text x={cx} y={Y_ODPAD + 19} textAnchor="middle" fill={ODPAD} fontSize="14" fontWeight="700">
                {k.odpad}
              </text>
              <text x={cx} y={Y_ODPAD + 35} textAnchor="middle" fill="#9F1239" fontSize="10">
                odešlo ({pct(k.odpad, k.value)} %)
              </text>
            </g>
          );
        })}

        {/* uzly */}
        {kroky.map((k, i) => {
          const cx = x(i + odsazeni);
          const posledni = i === kroky.length - 1;
          const barva = posledni ? barvaKonce : k.barva || BRAND;
          return (
            <g key={k.key}>
              {/* Proužek nahoře ořízneme tvarem uzlu, jinak přeleze zaoblené rohy. */}
              <clipPath id={`uzel-${klic}-${k.key}`}>
                <rect x={cx} y={Y} width={UZEL_W} height={UZEL_H} rx="16" />
              </clipPath>
              <rect
                x={cx} y={Y} width={UZEL_W} height={UZEL_H} rx="16"
                fill={posledni ? "#ECFDF5" : "#fff"}
                stroke={barva}
                strokeWidth="2"
              />
              <g clipPath={`url(#uzel-${klic}-${k.key})`}>
                <rect x={cx} y={Y} width={UZEL_W} height="6" fill={barva} />
              </g>
              <text x={cx + UZEL_W / 2} y={Y + 34} textAnchor="middle" fill="#3F3A49" fontSize="13" fontWeight="600">
                {k.label}
              </text>
              <text
                x={cx + UZEL_W / 2} y={Y + 66}
                textAnchor="middle"
                fill={barva}
                fontSize="27" fontWeight="700"
              >
                {k.value}
              </text>
              {k.cas > 0 && (
                <text x={cx + UZEL_W / 2} y={Y + 86} textAnchor="middle" fill="#8A8394" fontSize="11">
                  {cas(k.cas)} v průměru
                </text>
              )}
            </g>
          );
        })}
      </svg>
    </div>
  );
}

export default function FlowMapa({ data }) {
  const tok = data?.tok || [];
  const uzly = data?.uzly || [];
  const vstupy = data?.vstupy || [];
  const casy = data?.casy || [];
  const casSouhrn = data?.casSouhrn || {};

  // "fit" = mapa se vejde do šířky karty a neposouvá se do stran.
  // Číslo = pevné zvětšení, teprve tehdy má smysl vodorovné posouvání.
  const [zoom, setZoom] = useState("fit");
  const fit = zoom === "fit";

  const { plna, sleva, vedlejsi, prazdno, maSlevu } = useMemo(() => {
    const jako = (p) => (Array.isArray(p) ? p : [p]);
    const casNa = (p) => jako(p).reduce((a, c) => a + (casy.find((z) => z.path === c)?.prumer_s || 0), 0);
    const navstevnicNa = (p) =>
      jako(p).reduce((a, c) => a + (uzly.find((u) => u.path === c)?.navstevnice || 0), 0);

    // Kolik jich z dané stránky odešlo z webu (nepokračovaly nikam dál).
    const odchodZ = (p) =>
      tok.filter((t) => jako(p).includes(t.z) && t.na === "(odchod)").reduce((a, b) => a + b.pocet, 0);

    // Kolik jich přešlo přímo z jedné stránky na druhou.
    const prechod = (z, na) =>
      tok
        .filter((t) => jako(z).includes(t.z) && jako(na).includes(t.na))
        .reduce((a, b) => a + b.pocet, 0);

    const kviz = navstevnicNa(PATH_KVIZ);
    const prodej = navstevnicNa(PATH_PRODEJ);
    const nakup = navstevnicNa(PATH_NAKUP);
    const slevaStranka = navstevnicNa(PATH_SLEVA);
    const slevaNakup = navstevnicNa(PATH_SLEVA_NAKUP);
    const zaplacenoCelkem = navstevnicNa(PATH_DEKUJI);
    const celkem = uzly.reduce((a, b) => Math.max(a, b.navstevnice), 0);

    // Zaplacené se rozdělí podle toho, z které pokladny žena na děkovací
    // stránku přišla. Co se přiřadit nepodaří, spadne do plné ceny, ať se
    // nikde neztratí koruna, kterou jsme opravdu dostali.
    const zaplacenoSleva = Math.min(prechod(PATH_SLEVA_NAKUP, PATH_DEKUJI), zaplacenoCelkem);
    const zaplacenoPlna = Math.max(zaplacenoCelkem - zaplacenoSleva, 0);

    const plna = [
      { key: "zdroj", label: "Příchod na web", icon: Users, value: celkem, odpad: 0, cas: 0 },
      { key: "kviz", label: "Kvíz", icon: HelpCircle, value: kviz, odpad: odchodZ(PATH_KVIZ), cas: casNa(PATH_KVIZ) },
      { key: "prodej", label: "Prodejní stránka", icon: FileText, value: prodej, odpad: odchodZ(PATH_PRODEJ), cas: casNa(PATH_PRODEJ) },
      { key: "nakup", label: "Nákupní stránka", icon: ShoppingCart, value: nakup, odpad: odchodZ(PATH_NAKUP), cas: casNa(PATH_NAKUP) },
      { key: "hotovo", label: "Zaplaceno", icon: CheckCircle2, value: zaplacenoPlna, odpad: 0, cas: casNa(PATH_DEKUJI) },
    ];

    const sleva = [
      { key: "s-stranka", label: "Stránka se slevou", value: slevaStranka, odpad: odchodZ(PATH_SLEVA), cas: casNa(PATH_SLEVA), barva: SLEVA },
      { key: "s-nakup", label: "Pokladna se slevou", value: slevaNakup, odpad: odchodZ(PATH_SLEVA_NAKUP), cas: casNa(PATH_SLEVA_NAKUP), barva: SLEVA },
      { key: "s-hotovo", label: "Zaplaceno se slevou", value: zaplacenoSleva, odpad: 0, cas: 0 },
    ];

    // Přechody, které nejdou po hlavní ose. Ukazují, kudy funnel opravdu teče.
    const hlavni = new Set();
    for (const a of PATH_PRODEJ) hlavni.add(`${PATH_KVIZ}|${a}`);
    for (const a of PATH_PRODEJ) for (const b of PATH_NAKUP) hlavni.add(`${a}|${b}`);
    for (const a of PATH_NAKUP) for (const b of PATH_DEKUJI) hlavni.add(`${a}|${b}`);
    for (const a of PATH_SLEVA) for (const b of PATH_SLEVA_NAKUP) hlavni.add(`${a}|${b}`);
    for (const a of PATH_SLEVA_NAKUP) for (const b of PATH_DEKUJI) hlavni.add(`${a}|${b}`);

    return {
      plna,
      sleva,
      maSlevu: slevaStranka > 0 || slevaNakup > 0 || zaplacenoSleva > 0,
      prazdno: plna.every((k) => !k.value) && slevaStranka === 0,
      vedlejsi: tok
        .filter((t) => t.na !== "(odchod)" && !hlavni.has(`${t.z}|${t.na}`))
        .slice(0, 8),
    };
  }, [tok, uzly, casy]);

  if (prazdno) {
    return (
      <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center text-sm text-slate-500">
        Zatím není co kreslit. Mapa se objeví, jakmile na web někdo přijde.
      </div>
    );
  }

  const tlacitko = (hodnota, popis, Ikona, text) => (
    <button
      type="button"
      onClick={() => setZoom(hodnota)}
      title={popis}
      className={`inline-flex items-center gap-1.5 rounded-xl px-2.5 py-1.5 text-xs font-medium transition ${
        zoom === hodnota ? "bg-brand-600 text-white" : "text-slate-500 hover:bg-slate-100"
      }`}
    >
      <Ikona className="w-3.5 h-3.5" /> {text}
    </button>
  );

  return (
    <div className="space-y-4">
      {(casSouhrn.celkem_min > 0 || casSouhrn.prumer_s > 0) && (
        <div className="flex flex-wrap items-center gap-x-3 gap-y-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm">
          <span className="font-medium text-slate-900">Čas na webu</span>
          <span aria-hidden className="h-3 w-px bg-slate-300" />
          <span className="text-slate-600">
            celkem <strong className="tabular-nums text-slate-900">{casSouhrn.celkem_min} min</strong>
          </span>
          <span aria-hidden className="h-3 w-px bg-slate-300" />
          <span className="text-slate-600">
            na jednu návštěvnici <strong className="tabular-nums text-slate-900">{cas(casSouhrn.prumer_s) || "0 s"}</strong>
          </span>
          {casSouhrn.visitoru > 0 && (
            <>
              <span aria-hidden className="h-3 w-px bg-slate-300" />
              <span className="text-slate-600">
                z <strong className="tabular-nums text-slate-900">{casSouhrn.visitoru}</strong> měřených návštěv
              </span>
            </>
          )}
        </div>
      )}

      {/* ------------------------------------------------ větev za plnou cenu */}
      <div className="rounded-2xl border border-slate-200 bg-white p-3">
        <div className="mb-2 flex items-center justify-between gap-2">
          <h3 className="pl-2 text-sm font-semibold text-slate-900">Plná cena, cesta z kvízu</h3>
          <div className="flex items-center gap-1">
            {tlacitko("fit", "Vejde se na šířku, bez posouvání", Maximize2, "Vejít se")}
            {tlacitko(1, "Skutečná velikost", ZoomOut, "100 %")}
            {tlacitko(1.5, "Přiblížit, mapa se pak posouvá do stran", ZoomIn, "150 %")}
          </div>
        </div>
        <Schema kroky={plna} zoom={zoom} fit={fit} klic="plna" />
      </div>

      {/* --------------------------------------------------- větev tajná sleva */}
      <div className="rounded-2xl border border-amber-200 bg-white p-3">
        <div className="mb-2 flex flex-wrap items-center gap-2 pl-2">
          <Tag className="h-4 w-4 text-amber-700" />
          <h3 className="text-sm font-semibold text-slate-900">Tajná sleva, cesta z e-mailu</h3>
          <span className="text-xs text-slate-500">
            Sem se nedá dojít z webu ani z kvízu, jen odkazem s odpočtem z e-mailu.
          </span>
        </div>
        {maSlevu ? (
          <Schema kroky={sleva} odsazeni={2} zoom={zoom} fit={fit} klic="sleva" />
        ) : (
          <p className="px-2 py-6 text-center text-sm text-slate-500">
            Za tohle období nikdo na stránku s tajnou slevou nepřišel. Objeví se, jakmile odejde
            e-mail s odpočtem a někdo na odkaz klikne.
          </p>
        )}
      </div>

      <p className="px-1 text-xs leading-relaxed text-slate-500">
        Čísla na spojnicích jsou ženy, které se dostaly do dalšího kroku, procento pod nimi říká,
        kolik jich prošlo z předchozího kroku. Červené větve dolů jsou odchody z webu.
        Počítáme různé návštěvnice, ne zobrazení stránek. Zaplacené dělíme podle toho, ze které
        pokladny žena na děkovací stránku došla.
      </p>

      {/* ---------------------------------------------- odkud přicházejí */}
      {!!vstupy.length && (
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <h3 className="mb-3 flex items-center gap-2 text-base font-semibold text-slate-900">
            <Users className="w-4 h-4 text-brand-600" /> Kudy vstupují na web
          </h3>
          <ul className="space-y-2">
            {vstupy.slice(0, 10).map((v, i) => (
              <li key={i} className="flex flex-wrap items-center gap-2 text-sm">
                <span className="rounded-full bg-brand-100 px-2.5 py-0.5 text-brand-800">{v.zdroj}</span>
                <span className="text-slate-400">→</span>
                <code className="rounded bg-slate-100 px-2 py-0.5 text-slate-700">{v.path}</code>
                <span className="ml-auto tabular-nums font-medium text-slate-900">{v.pocet}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* ------------------------------------------- vedlejší cesty webem */}
      {!!vedlejsi.length && (
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <h3 className="mb-1 flex items-center gap-2 text-base font-semibold text-slate-900">
            <LogOut className="w-4 h-4 text-brand-600" /> Kudy ještě chodí
          </h3>
          <p className="mb-3 text-xs text-slate-500">
            Přechody mimo hlavní osu funnelu. Když je některý silný, funnel teče jinudy, než jsme zamýšleli.
          </p>
          <ul className="space-y-2">
            {vedlejsi.map((t, i) => (
              <li key={i} className="flex flex-wrap items-center gap-2 text-sm">
                <code className="rounded bg-slate-100 px-2 py-0.5 text-slate-700">{t.z}</code>
                <span className="text-slate-400">→</span>
                <code className="rounded bg-slate-100 px-2 py-0.5 text-slate-700">{t.na}</code>
                <span className="ml-auto tabular-nums font-medium text-slate-900">{t.pocet}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
